package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.repository.GameTableRepository

class GetTableByIdUseCase(
    private val gameTableRepository: GameTableRepository
) {
    suspend operator fun invoke(tableId: String): Result<GameTable?> {
        return gameTableRepository.getTableById(tableId)
    }
}
